import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

export class AuthFooter extends React.Component {
  render() {
    return (
      <div style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Stack direction="row" spacing={1} sx={{ mt: 5 }} justifyContent={'space-around'} alignContent={'center'} alignItems={'center'}>
          <Typography color="gray" sx={{ fontSize: '12px', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              Microsoft Partner
          </Typography>
          <Typography color="gray" sx={{ fontSize: '12px', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              Google verified
          </Typography>
          <Typography color="gray" sx={{ fontSize: '12px', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              EU GDPR Compliant
          </Typography>
        </Stack>
        
        <Stack direction="row" spacing={1} sx={{ mt: 1 }} justifyContent={'space-around'} alignContent={'center'} alignItems={'center'}>
          <Typography color="gray" sx={{ fontSize: '12px', textAlign: 'center' }}>
            <Link href="https://dmonk.ai/terms.html" underline="hover" target="_blank" rel="noopener noreferrer" sx={{ mr: 1, color: 'gray' }}>
              Terms of Use
            </Link>
            <Link href="https://dmonk.ai/privacyusers.html" underline="hover" target="_blank" rel="noopener noreferrer" sx={{ ml: 1, color: 'gray' }}>
              Privacy Policy
            </Link>
          </Typography>
        </Stack>
        
        <Stack direction="row" spacing={1} sx={{ mt: 1 }} justifyContent={'space-around'} alignContent={'center'} alignItems={'center'}>
          <Typography color="gray" sx={{ fontSize: '12px', textAlign: 'center' }}>
            &copy; 2025 dMonk.ai. All rights reserved.
          </Typography>
        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent={'space-around'} alignContent={'center'} alignItems={'center'}>
          <Typography color="gray" sx={{ fontSize: '12px', textAlign: 'center' }}>
            dmonk.ai ApS - CVR - 44832282 - Copenhagen, Denmark
          </Typography>
        </Stack>
      </div>
    );
  }
}
